import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6657873c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main-content"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_GroupPolicySettings = _resolveComponent("GroupPolicySettings")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "group-policy-drawer",
    title: _ctx.title,
    "model-value": _ctx.modelValue,
    "show-close": "",
    size: "75%",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "row-label",
              title: _ctx.$t('policyManageExtra.policyName')
            }, _toDisplayString(_ctx.$t('policyManageExtra.policyName')), 9, _hoisted_2),
            _createVNode(_component_el_input, {
              size: "small",
              readonly: _ctx.operateType === _ctx.OperateType.read,
              modelValue: _ctx.policyData.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.policyData.name) = $event)),
              modelModifiers: { trim: true },
              placeholder: _ctx.$t('common.phStrategyName'),
              onInput: _ctx.inputName,
              maxlength: 20
            }, null, 8, ["readonly", "modelValue", "placeholder", "onInput"]),
            _createElementVNode("div", {
              class: "row-label",
              title: _ctx.$t('policyManageExtra.policyConfig')
            }, _toDisplayString(_ctx.$t('policyManageExtra.policyConfig')), 9, _hoisted_3),
            _createVNode(_component_GroupPolicySettings, {
              "policy-id": _ctx.policyId || _ctx.policyData.id,
              "operate-type": _ctx.operateType,
              "active-tab": _ctx.activeTab,
              onCancel: _ctx.handleClose,
              onSave: _ctx.handleSave
            }, null, 8, ["policy-id", "operate-type", "active-tab", "onCancel", "onSave"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "model-value", "onClose"]))
}